import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { postApi } from "../Services/services";
import { rcsServices } from "../Services/rcsServices";

export const store = configureStore({
  reducer: {
    [postApi.reducerPath]: postApi.reducer,
    [rcsServices.reducerPath]: rcsServices.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(postApi.middleware, rcsServices.middleware),
});
setupListeners(store.dispatch);
